var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWozx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.326 13.5 4.33-2.5-4.33-2.5-4.306-2.485L15.994 6l-4.331 2.5-4.319 2.492-.013.008v10l.005.003 4.328 2.497 4.331 2.5.007-.004 4.325-2.496 4.332-2.5-4.331-2.5-2.166 1.25-2.154 1.243-.012.007-2.166-1.25-2.16-1.247-.005-.003 4.33-2.5-4.33-2.5.01-.006 2.156-1.244L15.993 11l.021.012 2.145 1.238 2.166 1.25zM15.994 1l.03.017 6.467 3.733L28.99 8.5v15l-6.499 3.75L15.997 31h-.002l-6.497-3.75-6.496-3.75v-15l.016-.01 6.481-3.74L15.994 1z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWozx);
export default __webpack_public_path__ + "static/media/WOZX.f49dd30cce8e6bcb04611424c7177837.svg";
export { ForwardRef as ReactComponent };